import { composeHOCs } from 'shared/utils/composeHOCs';
import { memo, ReactElement } from 'react';

import { withProcessesData } from 'components/common/withProcessesData';
import { withRedirect } from 'components/common/withRedirect';
import { withIssueForm } from 'components/common/withIssueForm';
import { withProjectChangeDialog } from 'components/common/withProjectChangeDialog';
import { withUsers } from 'components/dataProviders/withUsers';
import { areObjectIdsEqual } from 'helpers/idComparison';
import {
  UrlParamName,
  useAppUrlParams,
} from 'hooks/navigation/useAppUrlParams';
import {
  useInspection,
  useInspectionTemplateOnView,
  withInspectionStore,
} from 'store/inspection';
import { InspectionViewContainer } from 'views/inspection/inspectionView/InspectionViewContainer';
import { SingleInspectionSkeleton } from './skeleton';

function InspectionContent(): ReactElement {
  const { inspection, loading: loadingInspection } = useInspection();
  const { template, loading: loadingTemplate } = useInspectionTemplateOnView();
  const inspectionIdParam = useAppUrlParams(UrlParamName.INSPECTION_ID);

  const isCurrentRouteInspection =
    !inspectionIdParam || areObjectIdsEqual(inspection?._id, inspectionIdParam);

  const isViewReady =
    !loadingInspection &&
    !loadingTemplate &&
    Boolean(inspection) &&
    Boolean(template) &&
    isCurrentRouteInspection;

  if (!isViewReady) {
    return <SingleInspectionSkeleton />;
  }

  // Export/import to documentation is mounted only in UnifiedIssueViewContainer
  // (WithExportToDocumentation / WithImportFromDocumentation). Not here: no withIssue.
  return <InspectionViewContainer />;
}

export const MemoInspection = memo(
  composeHOCs(
    withProjectChangeDialog,
    withProcessesData,
    withIssueForm,
    withRedirect,
    withUsers,
    withInspectionStore
  )(InspectionContent)
);
